import React from "react";
import PropTypes from "prop-types";
import { Redirect, Route } from "react-router-dom";
import VouchersAccessList from "./VouchersAccessList";
import VouchersParkingList from "./VouchersParkingList";
import VouchersTransportList from "./VouchersTransportList";
import VouchersAccessCreate from "./VouchersAccessCreate";
import VouchersAccessEdit from "./VouchersAccessEdit";
import VouchersParkingCreate from "./VouchersParkingCreate";
import VouchersTransportCreate from "./VouchersTransportCreate";
import VouchersParkingEdit from "./VouchersParkingEdit";
import VouchersTransportEdit from "./VouchersTransportEdit";

class Vouchers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static propTypes = {
    event: PropTypes.object,
    location: PropTypes.object,
    "location.pathname": PropTypes.object,
    "location.pathname.endsWith": PropTypes.func
  };

  render() {
    const { event } = this.props;

    return (
      <div className="row">
        <div className="col-12">
          <div className="m-portlet m-portlet--tabs">
            {this.props.location.pathname.endsWith("vouchers") && (
              <Redirect to={"/admin/events/" + event.id + "/vouchers/access"} />
            )}
            <Route
              exact
              path="/admin/events/:id/vouchers/access"
              render={routeProps => (
                <VouchersAccessList {...routeProps} event={event} />
              )}
            />
            <Route
              exact
              path="/admin/events/:id/vouchers/access/create"
              render={routeProps => (
                <VouchersAccessCreate {...routeProps} event={event} />
              )}
            />
            <Route
              exact
              path="/admin/events/:id/vouchers/access/:voucherId/edit"
              render={routeProps => (
                <VouchersAccessEdit {...routeProps} event={event} />
              )}
            />

            <Route
              exact
              path="/admin/events/:id/vouchers/parking"
              render={routeProps => (
                <VouchersParkingList {...routeProps} event={event} />
              )}
            />
            <Route
              exact
              path="/admin/events/:id/vouchers/parking/create"
              render={routeProps => (
                <VouchersParkingCreate {...routeProps} event={event} />
              )}
            />
            <Route
              exact
              path="/admin/events/:id/vouchers/parking/:voucherId/edit"
              render={routeProps => (
                <VouchersParkingEdit {...routeProps} event={event} />
              )}
            />

            <Route
              exact
              path="/admin/events/:id/vouchers/transport"
              render={routeProps => (
                <VouchersTransportList {...routeProps} event={event} />
              )}
            />
            <Route
              exact
              path="/admin/events/:id/vouchers/transport/create"
              render={routeProps => (
                <VouchersTransportCreate {...routeProps} event={event} />
              )}
            />
            <Route
              exact
              path="/admin/events/:id/vouchers/transport/:voucherId/edit"
              render={routeProps => (
                <VouchersTransportEdit {...routeProps} event={event} />
              )}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Vouchers;
